var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.infoData && _vm.infoData.visible)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"ml-2 my-auto",attrs:{"color":"var(--color-text)"}},'v-icon',attrs,false),on),[_vm._v("\n      mdi-information-outline\n    ")])]}}],null,false,4150484617)},[_c('span',[_vm._v(_vm._s(_vm.infoData.description))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }